var map = {
	"./af": 52,
	"./af.js": 52,
	"./ar": 57,
	"./ar-ly": 53,
	"./ar-ly.js": 53,
	"./ar-ma": 54,
	"./ar-ma.js": 54,
	"./ar-sa": 55,
	"./ar-sa.js": 55,
	"./ar-tn": 56,
	"./ar-tn.js": 56,
	"./ar.js": 57,
	"./az": 58,
	"./az.js": 58,
	"./be": 59,
	"./be.js": 59,
	"./bg": 60,
	"./bg.js": 60,
	"./bn": 61,
	"./bn.js": 61,
	"./bo": 62,
	"./bo.js": 62,
	"./br": 63,
	"./br.js": 63,
	"./bs": 64,
	"./bs.js": 64,
	"./ca": 65,
	"./ca.js": 65,
	"./cs": 66,
	"./cs.js": 66,
	"./cv": 67,
	"./cv.js": 67,
	"./cy": 68,
	"./cy.js": 68,
	"./da": 69,
	"./da.js": 69,
	"./de": 71,
	"./de-at": 70,
	"./de-at.js": 70,
	"./de.js": 71,
	"./dv": 72,
	"./dv.js": 72,
	"./el": 73,
	"./el.js": 73,
	"./en-au": 74,
	"./en-au.js": 74,
	"./en-ca": 75,
	"./en-ca.js": 75,
	"./en-gb": 76,
	"./en-gb.js": 76,
	"./en-ie": 77,
	"./en-ie.js": 77,
	"./en-nz": 78,
	"./en-nz.js": 78,
	"./eo": 79,
	"./eo.js": 79,
	"./es": 81,
	"./es-do": 80,
	"./es-do.js": 80,
	"./es.js": 81,
	"./et": 82,
	"./et.js": 82,
	"./eu": 83,
	"./eu.js": 83,
	"./fa": 84,
	"./fa.js": 84,
	"./fi": 85,
	"./fi.js": 85,
	"./fo": 86,
	"./fo.js": 86,
	"./fr": 89,
	"./fr-ca": 87,
	"./fr-ca.js": 87,
	"./fr-ch": 88,
	"./fr-ch.js": 88,
	"./fr.js": 89,
	"./fy": 90,
	"./fy.js": 90,
	"./gd": 91,
	"./gd.js": 91,
	"./gl": 92,
	"./gl.js": 92,
	"./he": 93,
	"./he.js": 93,
	"./hi": 94,
	"./hi.js": 94,
	"./hr": 95,
	"./hr.js": 95,
	"./hu": 96,
	"./hu.js": 96,
	"./hy-am": 97,
	"./hy-am.js": 97,
	"./id": 98,
	"./id.js": 98,
	"./is": 99,
	"./is.js": 99,
	"./it": 100,
	"./it.js": 100,
	"./ja": 101,
	"./ja.js": 101,
	"./jv": 102,
	"./jv.js": 102,
	"./ka": 103,
	"./ka.js": 103,
	"./kk": 104,
	"./kk.js": 104,
	"./km": 105,
	"./km.js": 105,
	"./ko": 106,
	"./ko.js": 106,
	"./ky": 107,
	"./ky.js": 107,
	"./lb": 108,
	"./lb.js": 108,
	"./lo": 109,
	"./lo.js": 109,
	"./lt": 110,
	"./lt.js": 110,
	"./lv": 111,
	"./lv.js": 111,
	"./me": 112,
	"./me.js": 112,
	"./mi": 113,
	"./mi.js": 113,
	"./mk": 114,
	"./mk.js": 114,
	"./ml": 115,
	"./ml.js": 115,
	"./mr": 116,
	"./mr.js": 116,
	"./ms": 118,
	"./ms-my": 117,
	"./ms-my.js": 117,
	"./ms.js": 118,
	"./my": 119,
	"./my.js": 119,
	"./nb": 120,
	"./nb.js": 120,
	"./ne": 121,
	"./ne.js": 121,
	"./nl": 122,
	"./nl.js": 122,
	"./nn": 123,
	"./nn.js": 123,
	"./pa-in": 124,
	"./pa-in.js": 124,
	"./pl": 125,
	"./pl.js": 125,
	"./pt": 127,
	"./pt-br": 126,
	"./pt-br.js": 126,
	"./pt.js": 127,
	"./ro": 128,
	"./ro.js": 128,
	"./ru": 129,
	"./ru.js": 129,
	"./se": 130,
	"./se.js": 130,
	"./si": 131,
	"./si.js": 131,
	"./sk": 132,
	"./sk.js": 132,
	"./sl": 133,
	"./sl.js": 133,
	"./sq": 134,
	"./sq.js": 134,
	"./sr": 136,
	"./sr-cyrl": 135,
	"./sr-cyrl.js": 135,
	"./sr.js": 136,
	"./ss": 137,
	"./ss.js": 137,
	"./sv": 138,
	"./sv.js": 138,
	"./sw": 139,
	"./sw.js": 139,
	"./ta": 140,
	"./ta.js": 140,
	"./te": 141,
	"./te.js": 141,
	"./th": 142,
	"./th.js": 142,
	"./tl-ph": 143,
	"./tl-ph.js": 143,
	"./tlh": 144,
	"./tlh.js": 144,
	"./tr": 145,
	"./tr.js": 145,
	"./tzl": 146,
	"./tzl.js": 146,
	"./tzm": 148,
	"./tzm-latn": 147,
	"./tzm-latn.js": 147,
	"./tzm.js": 148,
	"./uk": 149,
	"./uk.js": 149,
	"./uz": 150,
	"./uz.js": 150,
	"./vi": 151,
	"./vi.js": 151,
	"./x-pseudo": 152,
	"./x-pseudo.js": 152,
	"./zh-cn": 153,
	"./zh-cn.js": 153,
	"./zh-hk": 154,
	"./zh-hk.js": 154,
	"./zh-tw": 155,
	"./zh-tw.js": 155
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 275;



/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/moment/locale ^\.\/.*$
 ** module id = 275
 ** module chunks = 1
 **/